export const FormControlLabelSx = {
  gap: '6px',
  margin: 0,
  alignItems: 'center',
  '.MuiTypography-root': {
    fontSize: '14px',
    color: 'customColors.gray.950',
    letterSpacing: 0,
  },
  '& .MuiTypography-root': {
    display: 'inline-block',
  },
  '&.error .MuiTypography-root': {
    color: 'error.main',
  },
  '& .MuiButtonBase-root.MuiCheckbox-root': {
    paddingTop: '1px',
  },
};
